import React from 'react';
import * as S from './tool-tip.styles';
import ReviewBlock from './review-block';

const ToolTipForHotels = ({ reviewText, hotel }) => {
  return (
    <S.ToolTip>
      <S.ReviewTxt className="greyCnt lh1-5">{reviewText}</S.ReviewTxt>
      <div className="tip tip_top right whiteBg">
        <ReviewBlock hotel={hotel} />
      </div>
    </S.ToolTip>
  );
};

export default ToolTipForHotels;
